//About Us page 
import React, { useEffect } from "react";
import { FaRocket, FaEnvelope, FaUsers, FaBullseye, FaLightbulb, FaTools, FaBook, FaHandshake, FaLinkedin } from 'react-icons/fa';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex justify-center min-h-[80vh]">
      <div className="text-green p-8 rounded w-full">
        <h2 className="text-3xl font-bold mb-8 text-center">About Us</h2>
        
        <div className="mb-8">
          <div className="flex items-center mb-4">
            <FaUsers className="text-2xl mr-3" />
            <h3 className="text-2xl font-semibold">Who We Are</h3>
          </div>
          <p>
            At PlanX Universe, we are a team of AI enthusiasts, researchers, and developers passionate about advancing the field of automated planning. We created PSpace as an open repository to bridge the gap between planning practitioners along with software developers and the research community.
          </p>
        </div>

        <div className="mb-8">
          <div className="flex items-center mb-4">
            <FaBullseye className="text-2xl mr-3" />
            <h3 className="text-2xl font-semibold">Our Mission</h3>
          </div>
          <p>
            Our mission is to make AI planning tools more discoverable, accessible, and collaborative. We empower users to find, compare, and contribute to cutting-edge planning technologies.
          </p>
        </div>

        <div className="mb-8">
          <div className="flex items-center mb-4">
            <FaLightbulb className="text-2xl mr-3" />
            <h3 className="text-2xl font-semibold">Why It Matters</h3>
          </div>
          <p>
            The field of automated planning plays a critical role in robotics, logistics, smart buildings, autonomous driving, cloud computing, games, and more. Yet, valuable tools often remain siloed or underused. PSpace democratizes access to these innovations.
          </p>
        </div>

        <div className="mb-8">
          <div className="flex items-center mb-4">
            <FaTools className="text-2xl mr-3" />
            <h3 className="text-2xl font-semibold">What We Offer</h3>
          </div>
          <ul className="list-disc pl-6">
            <li>A centralized platform for publishing and discovering planning software.</li>
            <li>Criteria to characterize and rate planning software.</li>
            <li>Community features for feedback and collaboration.</li>
          </ul>
        </div>

        <div className="mb-8">
          <div className="flex items-center mb-4">
            <FaBook className="text-2xl mr-3" />
            <h3 className="text-2xl font-semibold">Our Story</h3>
          </div>
          <p>
            PlanX Universe was born out of real-world needs at the University of Stuttgart's Service Computing Department. Our work is rooted in open science and aims to promote reproducibility and collaboration in AI planning research.
          </p>
        </div>

        <div className="mb-8">
          <div className="flex items-center mb-4">
            <FaUsers className="text-2xl mr-3" />
            <h3 className="text-2xl font-semibold">Contributors to PSpace</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-white/10 p-4 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-green-200/20">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-green-600 flex items-center justify-center text-white text-xl font-bold">
                  IG
                </div>
                <h4 className="text-lg font-semibold mb-1"> Dr. Ilche Georgievski</h4>
                <a 
                  href="https://www.linkedin.com/in/igeorgievski/?originalSubdomain=de" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-gray-600 hover:text-green-600 transition-colors"
                >
                  <FaLinkedin className="text-lg" />
                </a>
              </div>
            </div>

            <div className="bg-white/10 p-4 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-green-200/20">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-green-600 flex items-center justify-center text-white text-xl font-bold">
                  SA
                </div>
                <h4 className="text-lg font-semibold mb-1">Saurabh Adhau</h4>
                <a 
                  href="https://www.linkedin.com/in/saurabhadhau/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-gray-600 hover:text-green-600 transition-colors"
                >
                  <FaLinkedin className="text-lg" />
                </a>
              </div>
            </div>

            
            <div className="bg-white/10 p-4 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-green-200/20">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-green-600 flex items-center justify-center text-white text-xl font-bold">
                  AM
                </div>
                <h4 className="text-lg font-semibold mb-1">Ayush Mittal</h4>
                <a 
                  href="https://www.linkedin.com/in/ayushmittal129/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-gray-600 hover:text-green-600 transition-colors"
                >
                  <FaLinkedin className="text-lg" />
                </a>
              </div>
            </div>
            <div className="bg-white/10 p-4 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-green-200/20">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-green-600 flex items-center justify-center text-white text-xl font-bold">
                  DG
                </div>
                <h4 className="text-lg font-semibold mb-1">Deep Gawande</h4>
                <a 
                  href="https://www.linkedin.com/in/deep-gawande/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-gray-600 hover:text-green-600 transition-colors"
                >
                  <FaLinkedin className="text-lg" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-8">
          <div className="flex items-center mb-4">
            <FaHandshake className="text-2xl mr-3" />
            <h3 className="text-2xl font-semibold">Backed By</h3>
          </div>
          <p>
            Service Computing Department, Institute of Architecture of Application Systems, University of Stuttgart
          </p>
        </div>

        <div className="mb-8">
          <div className="flex items-center mb-4">
            <FaRocket className="text-2xl mr-3" />
            <h3 className="text-2xl font-semibold">Get Involved</h3>
          </div>
          <p className="mb-4">
            Want to contribute a planner? Curious to try one out? We welcome developers, researchers, and industry practitioners alike.
          </p>
          <div className="flex gap-4">
            <a 
              href="https://pspace.planxverse.com/add-tool" 
              className="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-lg transition-all duration-300 hover:bg-green-700 hover:scale-105 hover:shadow-lg"
            >
              <FaRocket className="mr-2" />
              Submit a Planner
            </a>
            <a 
              href="mailto:planx.universe@gmail.com" 
              className="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-lg transition-all duration-300 hover:bg-green-700 hover:scale-105 hover:shadow-lg"
            >
              <FaEnvelope className="mr-2" />
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
